import hiraganaLayout from './hiragana';
import abcLayout from './abc';
import numbersLayout from './numbers';

export { hiraganaLayout, abcLayout, numbersLayout };

// Default export remains the hiragana layout for BASE_KEYBOARD_BY_LANGUAGE
export default hiraganaLayout;
